











import { Vue, Component } from "vue-property-decorator";
import List from "@/components/grace/list.vue";
import { getGraceList } from "@/http/grace.api";
import { Getter } from "vuex-class";
import { myUpload } from "@/http/login.api";
@Component({
  components: {
    List
  }
})
export default class Grace extends Vue {
  list: Array<any> = [];
  loading = false;
  @Getter("isLogin") isLogin: any;
  async getList() {
    try {
      this.loading = true;
      const res = await getGraceList({ pageNum: 1, pageSize: 1000000 });
      this.list = res.data;
    } catch (error) {
      this.list = [];
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
  async jump() {
    await myUpload();
    this.$router.push(`/grace/add`);
  }
  mounted() {
    this.getList();
  }
}
